import { render } from "./WordEndingsNouns.vue?vue&type=template&id=e6093aaa&scoped=true"
import script from "./WordEndingsNouns.vue?vue&type=script&lang=js"
export * from "./WordEndingsNouns.vue?vue&type=script&lang=js"

import "./WordEndingsNouns.vue?vue&type=style&index=0&id=e6093aaa&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6093aaa"]])

export default __exports__